import '@/theme/styles.css'
import '@/localization'
import 'virtual:svg-icons-register'
import '@interchain-ui/react/styles'

import log from 'loglevel'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Ensure loglevel outputs in both dev and prod (errors at minimum)
log.setLevel(import.meta.env.DEV ? 'debug' : 'error')

import { App } from '@/App'
import { UiToaster } from '@/ui/UiToaster'

const root = createRoot(document.getElementById('root') as Element)

root.render(
  <StrictMode>
    <App />
    <UiToaster />
  </StrictMode>,
)
